import fetchHandler from "../../utils/fetchHandler";
import { RESOURCES } from "../types/actions";

export const getResources = (queryString) => {
	const fetchOptions = {
		url: `/api/resources?${queryString}`,
		method: "GET",
		actionType: RESOURCES.GET_RESOURCES
	};
	return fetchHandler(fetchOptions);
};

export const getResourceDetails = (id) => {
	const fetchOptions = {
		url: `/api/resources/${id}`,
		method: "GET",
		actionType: RESOURCES.GET_RESOURCE_DETAILS
	};
	return fetchHandler(fetchOptions);
};

export const resetResources = () => ({
	type: RESOURCES.RESET_RESOURCES
});

export const searchResources = (queryString) => {
	const fetchOptions = {
		url: `/api/resources?${queryString}`,
		method: "GET",
		actionType: RESOURCES.SEARCH_RESOURCES
	};
	return fetchHandler(fetchOptions);
};
